import React,{useState} from "react";
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory, Redirect } from "react-router-dom";
import "./Footer.css"


export default function Fotter() {

    const [userEmail, setuserEmail]= useState("");
    function handleChange(e){
        setuserEmail(e.target.value);
    }
    console.log(userEmail);
    function handleSubmit(e){
        e.preventDefault();
        console.log(userEmail);
    }


    return <footer>
        <div className="footer-container">
        <div className="foot-list-all">
            <div className="foot-list">
                <ul className="fooot-ul">
                    <li className="list-head-ftr">Diginoor</li>
                    <Link to ="/collections"><li className="ftr-li">Explore</li></Link>
                    <Link to ="/how%20it%20works"><li className="ftr-li">Help Center</li></Link>
                    <Link to ="/blog"><li className="ftr-li">Blog</li></Link>
                    <a href="https://linktr.ee/diginoor.io" target="_blank"><li className="ftr-li">Jobs</li></a>
                    <Link to ="/contact"><li className="ftr-li">Become a partner</li></Link>
                </ul>
            </div>
            <div className="foot-list foot-list-2">
                <ul className="fooot-ul" >
                    <li className="list-head-ftr" >Community</li>
                    <Link to ="/about"><li className="ftr-li">About</li></Link>
                    <Link to ="/contact"><li className="ftr-li">Suggest feature</li></Link>
                    <Link to ="/contact"><li className="ftr-li">Contact Us</li></Link>
                    <Link to ="/how%20it%20works"><li className="ftr-li">FAQS</li></Link>
                    <Link to ="/how%20it%20works"><li className="ftr-li">All about NFTs</li></Link>
                </ul>
            </div>
            
        </div>
        <div className="foot-rightt">
            <div>
                <h3 className="subs-ftr">Subscribe to our Newsletter</h3>
            </div>
            <div className="foot-tong">
               <form onSubmit={(e) => handleSubmit(e)} className="fot-form">
                   <input onChange = {(e) => handleChange(e)} name="email" value={userEmail} className="fot-input" type="text" placeholder="enter your mail id"></input><button className="fot-bt">I'm in</button>
               </form>
            </div>
            <div>
                <h3 className="fot-join">  Join the Diginoor Community</h3>
            </div>
            <br></br>
            <div className="footer-ic" >
                <a class="fb-ic social-md">
                <a href="https://www.facebook.com/diginoornft/" target="_blank"><i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                </a>
                <a class="tw-ic social-md">
                <a href="https://twitter.com/diginoor_NFT" target="_blank"><i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                </a>
                <a class="gplus-ic social-md">
                <a href="https://discord.gg/C2APxt2h4P" target="_blank"><i class="fab fa-discord fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                </a>
                <a class="li-ic social-md">
                <a href="https://www.linkedin.com/company/diginoor" target="_blank"> <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                </a>
                <a class="ins-ic social-md">
                   <a href="https://www.instagram.com/diginoor.io" target="_blank"><i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a> 
                </a>
                <a class="pin-ic social-md">
                  <a href="https://wa.me/+15714120310" target="_blank"> <i class="fab fa-whatsapp fa-lg white-text fa-2x"> </i></a>
                </a>
            </div>
        </div>
        <div className="line-fot">
        </div>
        <br></br>
        <div className="cpy-fot">
        <div className="footer-copyright text-left py-3">© 2021 Copyright
    <a href="#"> Diginoor Inc</a>
    <a href="/Termscondition" className="terms-fot">Terms & Condition</a>
    <a href="/Privacypolicy" className="terms-fot">Privacy Policy</a>
  </div>
  </div>
  </div>
    </footer>

}